import Modal from '@/shared/Modal'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import Button from '@/shared/Buttons/Button'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import SeparateLine from '@/shared/Forms/SeparateLine'
import { IDashboard, TCreateDashboardDTO } from '@/pages/Dashboards/dashboards.types.ts'
import dashboardsApi from '@/pages/Dashboards/dashboards.api.ts'
import dashboardsEvents from '@/pages/Dashboards/events/dashboards.events.ts'
import Toggle from '@/shared/Inputs/Toggle'
import useDashboard from '@/pages/Dashboards/hooks/useDashboard.ts'

interface IProps {
  open: boolean
  dashboard: IDashboard
  onClose: () => void
}

const UpdateDashboardModal = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [dashboard, _, handleChange] = useStateWithChange<TCreateDashboardDTO>(props.dashboard)

  const handleSave = () => {
    wait(
      dashboardsApi.updateDashboard({
        id: props.dashboard.id,
        name: dashboard.name,
        sharedWithOrganization: props.dashboard.sharedWithOrganization,
        groupId: dashboard.groupId,
      }),
      (resp) => {
        if (resp.status === 'success') {
          dashboardsEvents.updated(resp.body)
          props.onClose()
        }
      }
    )
  }

  return (
    <Modal title="Настройки дашборда" onClose={props.onClose} open={props.open} closeOnClickOutside={false}>
      <div className="flex-lines gap16">
        <FormField label="Наименование дашборда" required>
          <TextInput name="name" onChange={handleChange} value={dashboard.name} placeHolder="Введите наименование" />
        </FormField>
        <SeparateLine />
        <div className="inline-flex-gap gap8">
          <Toggle
            name="sharedWithOrganization"
            checked={dashboard.sharedWithOrganization}
            onChange={handleChange}
            size="large"
          />
          <p className="text-nm">Виден всем сотрудникам организации</p>
        </div>
        <p className="text-nm text-warning">
          {dashboard.sharedWithOrganization ? 'Дашборд виден всем сотрудникам организации' : 'Дашборд виден только вам'}
        </p>
        <SeparateLine />
        <div className="inline-flex-gap gap8">
          <Button size="default" type="default" text="Отмена" onClick={props.onClose} disabled={loading} />
          <Button size="default" type="primary" text="Создать" onClick={handleSave} loading={loading} />
        </div>
      </div>
    </Modal>
  )
}

export default (props: Omit<IProps, 'dashboard'> & { dashboardId: IDashboard['id'] }) => {
  const dashboard = useDashboard(props.dashboardId)

  if (!dashboard) return null
  return <UpdateDashboardModal {...props} dashboard={dashboard} key={dashboard.id} />
}
